import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformCmdkService {
  readonly open = signal(false);

  /**
   * Opens the command palette.
   */
  openCmdk(): void {
    this.open.set(true);
  }

  /**
   * Closes the command palette.
   */
  closeCmdk(): void {
    this.open.set(false);
  }

  /**
   * Toggles the command palette visibility.
   */
  toggleCmdk(): void {
    this.open.update((value) => !value);
  }
}
